module.exports = __webpack_public_path__ + "media/images/4-6b1ddba7.png";